import { useMutation } from '@tanstack/react-query';

import { logSentryError } from '@libs/common-next';

import { SentryErrors } from '@/shared/sentry';

import { AddSubscriptionResponse, addAutoshipSubscription } from '../api';

export type PostOrdergrooveAddSubscription = {
    quantity: number;
    basketId: string;
    publicId: string;
    productId: string;
    customerId: string;
    unitOfMeasure: number | null;
    frequencyAmount: number | null;
    isOneTimeOrder: boolean;
};

type UseAddAutoshipSubscriptionParams = {
    onError?: (error: Error) => void;
    onSuccess?: (response: AddSubscriptionResponse, variables: PostOrdergrooveAddSubscription) => void;
};

export function useAddAutoshipSubscription({ onError, onSuccess }: UseAddAutoshipSubscriptionParams = {}) {
    return useMutation({
        mutationFn: async (data: PostOrdergrooveAddSubscription) => {
            const response = await addAutoshipSubscription(data);

            if (!response) {
                throw new Error('No response from ordergroove subscription API');
            }

            return response;
        },
        onSuccess: (response, variables) => {
            onSuccess?.(response, variables);
        },
        onError: error => {
            logSentryError(error, SentryErrors.AutoshipAPI.AddAutoshipSubscriptionFailed);
            onError?.(error);
        },
    });
}
